import { Button, Flex, Heading } from "@chakra-ui/react"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Paths, breadCrumbFirstLevel } from "../../../common/commonConstants"
import { SubPage, SubPageContent } from "../../../components/SubPage"
import { BreadCrumb } from "../../../components/commons/breadcrumb"
import { scrollTo } from "../../../components/commons/utils"
import { CreateNewFMP } from "../createNewFMPButton.main"
import { MyFMPTable } from "./myFMPs.support"

export const MyFMPs = (): JSX.Element => {
  useEffect(() => {
    scrollTo(0, 0)
  }, [])

  const navigate = useNavigate()
  const navigateToPArchivedFMP = (): void => {
    navigate(Paths.FMP.MY_ARCHIVED_FMP)
  }

  return (
    <SubPage>
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          thirdLevel: { title: "MyFMPs" }
        }}
      />
      <SubPageContent props={{ pt: "22px" }} innerBoxProps={{ w: "90%" }}>
        <Flex justifyContent="space-between" alignItems="center" w="100%" mb="3">
          <Heading variant="RHeading1" textAlign="left" color="primary">
            Fire Management Plans
          </Heading>
          <Flex justifyContent="flex-end" alignItems="center" gridGap="12px">
            <Button variant="Button1RegularOutline" onClick={navigateToPArchivedFMP}>
              Show Archived FMPs
            </Button>
            <CreateNewFMP buttonProps={{ variant: "Button1RegularAccentWithShadow" }} />
          </Flex>
        </Flex>
        <MyFMPTable />
      </SubPageContent>
    </SubPage>
  )
}
